import type { IntegrationType } from '@/api/queries/integrations';

const MAILCHIMP_MARKETING_KEY = /^[0-9a-f]{32}-us\d{1,3}$/i;

const MAILCHIMP_TRANSACTIONAL_KEY_MESSAGE =
  'This is a Mailchimp Transactional (Mandrill) key. Datahub needs a Mailchimp Marketing API key (Profile → Extras → API keys); it ends with -usNN.';
const MAILCHIMP_KEY_FORMAT_MESSAGE =
  'Mailchimp API key must look like <32 hex characters>-usNN.';
const BREVO_SMTP_KEY_MESSAGE =
  'This is a Brevo SMTP key. Create an API v3 key (starts with xkeysib-).';

export function validateApiKey(type: IntegrationType, raw: string): string | null {
  const key = raw.trim();
  if (!key) return null;
  switch (type) {
    case 'mailchimp':
      if (key.startsWith('md-')) return MAILCHIMP_TRANSACTIONAL_KEY_MESSAGE;
      if (!MAILCHIMP_MARKETING_KEY.test(key)) return MAILCHIMP_KEY_FORMAT_MESSAGE;
      return null;
    case 'brevo':
      return key.startsWith('xsmtpsib-') ? BREVO_SMTP_KEY_MESSAGE : null;
    default:
      return null;
  }
}
